// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!./node_modules/vue-style-loader!./node_modules/css-loader??ref--9-2!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/lib??ref--9-3!./node_modules/sass-loader/dist/cjs.js??ref--9-4!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/page.vue?vue&type=style&index=0&id=6b610ce8&prod&lang=scss&scoped=true
// module id = RmTw
// module chunks = 190